import React from 'react';
import BlackHole from './Snowflakes';

function App() {
  return (
    <div className="App">
      <BlackHole />
    </div>
  );
}

export default App;